import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import { computed, flow, observable, runInAction } from "mobx";
import { realCommerceRequest, __ } from "../utils";
import { RealCommerceError } from "../exceptions";
import { routeLocationLicenseActivationDelete } from "@devowl-wp/api-real-commerce";
const CONNECT_LOST_MILLISECONDS = 3 * 24 * 60 * 60 * 1000;
let LicenseActivation = (_class = class LicenseActivation {
  get host() {
    var _this$data, _this$data$client$pro;
    return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$client$pro = _this$data.client.properties.filter(_ref => {
      let {
        key
      } = _ref;
      return key === "hostname";
    })[0]) === null || _this$data$client$pro === void 0 ? void 0 : _this$data$client$pro.value;
  }
  get pluginVersion() {
    var _this$data2, _this$data2$propertie;
    return ((_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : (_this$data2$propertie = _this$data2.properties.filter(_ref2 => {
      let {
        key
      } = _ref2;
      return key === "pluginVersion";
    })[0]) === null || _this$data2$propertie === void 0 ? void 0 : _this$data2$propertie.value) || __("Unknown");
  }
  get lastSeen() {
    var _this$data3, _this$data3$client$pr;
    const lastSeen = (_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : (_this$data3$client$pr = _this$data3.client.properties.filter(_ref3 => {
      let {
        key
      } = _ref3;
      return key === "lastSeen";
    })[0]) === null || _this$data3$client$pr === void 0 ? void 0 : _this$data3$client$pr.value;
    return lastSeen ? new Date(lastSeen) : undefined;
  }
  get isConnectionLost() {
    const now = Date.now();
    const {
      lastSeen
    } = this;
    return lastSeen ? now - lastSeen.getTime() > CONNECT_LOST_MILLISECONDS : false;
  }
  get session() {
    return this.store.store;
  }
  constructor(data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "busy", _descriptor2, this);
    this.store = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.delete = flow(function* () {
      this.busy = true;
      yield this.session.probablyRenewJwt();
      try {
        const {
          data: {
            license: {
              licenseKey
            },
            client: {
              uuid
            }
          }
        } = this;
        yield realCommerceRequest({
          location: routeLocationLicenseActivationDelete,
          request: {
            licenseActivation: {
              license: {
                licenseKey
              },
              client: {
                uuid
              }
            }
          },
          settings: {
            headers: this.session.authorizationHeader
          }
        });
        yield this.session.fetchLicenses();
        this.store.fetchActivations();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busy = false;
      }
    });
    this.store = store;
    runInAction(() => {
      this.data = data;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "host", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "host"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluginVersion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluginVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastSeen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isConnectionLost", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isConnectionLost"), _class.prototype)), _class);
export { LicenseActivation };